export default __webpack_public_path__ + "static/media/image-speaker-zx9.153cd899.png";